import React from 'react';

import empty from '../../../images/empty_img.svg';

import { FOHImage } from '../../ingredients';

export const FOHEmptyImageUploadIcon = () => (
  <FOHImage source={{ uri: empty }} style={{ width: 24, height: 24 }} />
);
